import React, {Component} from 'react'
import PropTypes from 'prop-types'
import OrdersError from './OrdersError'
import NoOrders from './NoOrders'
import OrdersList from './OrdersList'
import OrdersAllSelection from './head/OrdersAllSelection'
import {Spin} from 'antd'

class OrdersTable extends Component {
    state = {
        allSelected: false,
        selectedOrders: [],
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (JSON.stringify(prevProps.filters) !== JSON.stringify(this.props.filters)) {
            this.setState({
                allSelected: false,
                selectedOrders: [],
            })
        }
    }

    _checkStatus = (productionStatus) => {
        const listStatus = ['pushed', 'printed', 'confirmed', 'completed', 'cancel-ship', 'cancelled', 'shipped', 'transferring', 'transferred', 'sewing']

        return listStatus.includes(productionStatus)
    }

    _renderTableContent = () => {
        const {orders, error, isOrdersRefreshed, loading, onFetchOrders, itemsRequest, onChangeFilter} = this.props
        const {selectedOrders} = this.state

        if (error) {
            return <OrdersError error={error}/>
        }

        if (orders.length === 0) {
            return <NoOrders loading={loading}/>
        }

        return <OrdersList
            orders={orders}
            selectedOrders={selectedOrders}
            isOrdersRefreshed={isOrdersRefreshed}
            onUpdateOrdersSelected={this._updateOrdersSelected}
            onFetchOrders={onFetchOrders}
            checkStatus={this._checkStatus}
            itemsRequest={itemsRequest}
            onChangeFilter={onChangeFilter}
        />
    }

    _updateOrdersSelected = (id, isAdded) => {
        const {selectedOrders} = this.state
        const originOrders = this.props.orders

        if (isAdded) {
            if (!selectedOrders.includes(id)) {
                this.props.handleChangeSelectedBarcode([...selectedOrders, id])
                this.setState({
                    selectedOrders: [...selectedOrders, id],
                    allSelected: selectedOrders.length + 1 === originOrders.length,
                })
            }
        } else {
            const filtered = selectedOrders.filter(orderId => orderId !== id)
            this.props.handleChangeSelectedBarcode(filtered)

            this.setState({
                selectedOrders: filtered,
                allSelected: false,
            })
        }
    }

    _toggleSelectAll = (isChecked) => {
        this.setState(() => {
            if (isChecked) {
                const {orders} = this.props
                // eslint-disable-next-line array-callback-return
                const orderIds = orders.filter(order => {
                    const itemStatus = order.hasOwnProperty('sub_status') ? order.sub_status : order.production_status
                    if (this._checkStatus(itemStatus) === false && this._checkStatus(order.status) === false) {
                        return order._id
                    }
                })

                const neworderIds = orderIds.map(item => {
                    return item._id
                })
                
                if (orderIds.length > 0) {
                    this.props.handleChangeSelectedBarcode(neworderIds)
                    return {
                        selectedOrders: neworderIds,
                        allSelected: true,
                    }
                }
                return {
                    selectedOrders: [],
                    allSelected: false,
                }
            }
            
            this.props.handleChangeSelectedBarcode([])
            return {
                selectedOrders: [],
                allSelected: false,
            }
        })
    }

    _resetSelectOrder = () => {
        this.setState({
            selectedOrders: [],
            allSelected: false
        })
    }

    render() {
        const {allSelected, selectedOrders} = this.state
        const tableContent = this._renderTableContent()

        const {onFetchOrders, loading} = this.props

        return (
            <div className='OrdersTable'>
                <Spin spinning={loading} tip='Loading...'>
                    <table className='table table-borderless table-striped OrdersTable'>
                        <thead className='thead-light'>
                        <tr>
                            <OrdersAllSelection
                                isChecked={allSelected}
                                selectedOrders={selectedOrders}
                                onFetchOrders={onFetchOrders}
                                onToggleSelectAll={this._toggleSelectAll}
                                onResetSelectOrder={this._resetSelectOrder}
                            />
                            <th className='Template'>Template</th>
                            <th className='MockUp'>Mock up</th>
                            <th className='Design'>Design</th>
                            <th className='Image'>File in</th>
                            <th className='Type'>Loại sản phẩm</th>
                            <th className='Size'>Size</th>
                            <th className='Quantity'>Số lượng</th>
                            <th className='Status'>Trạng thái</th>
                            <th className='Error'>Lỗi</th>
                            <th className='Time'>Ngày tạo</th>
                            <th className='Time'>Ngày in</th>
                            <th className='Note'>Note</th>
                            <th className='Actions'>Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {tableContent}
                        </tbody>
                    </table>
                </Spin>
            </div>
        )
    }
}

OrdersTable.propTypes = {
    orders: PropTypes.array.isRequired,
    error: PropTypes.string.isRequired,
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    onFetchOrders: PropTypes.func.isRequired,
}

export default OrdersTable
